import type { IDeceased } from 'src/interfaces';

export const getDeceasedYearsLife = ({ dob, dod }: IDeceased) => {
  return `${dob} - ${dod}`;
};
